
















import Component from 'vue-class-component'
import {SubscriptionPlanModel, SubscriptionPlanType} from '@/services/types'
import {ISubscriptionPlanSelectProp} from './ISubscriptionPlanSelect'
import FormInput from '@/components/lib/input/FormInput.vue'


@Component({
    components: {
        FormInput
    }
})
export default class SubscriptionPlanSelect extends ISubscriptionPlanSelectProp {
    private componentClass = 'SubscriptionPlanSelect'

    private searchValue = ''

    get getPlansRenderList(): SubscriptionPlanModel [] {
        return (this.$store.getters.getSubscriptionPlansList as SubscriptionPlanModel []).map(item => {
            return {
                ...item,
                name: `${item.code} - ${item.name}`
            }
        })  
    }

    get getFilteredItemList(): SubscriptionPlanModel [] {
        if (this.searchValue.length >= 2) {
            return this.getPlansRenderList.filter(item => item.name.trim().toLowerCase().indexOf(this.searchValue.trim().toLowerCase()) >= 0)
        }
        else {
            return this.getPlansRenderList
        }        
    }

    isActive(code: SubscriptionPlanType) {
        return this.value == code
    }

    onSearchChange(search: string) {
        this.searchValue = search
    }

    get getTitle(): string {
        if (this.getPlansRenderList.find(item => item.code == this.value)) {
            return this.getPlansRenderList.find(item => item.code == this.value).name
        }
        else {
            return 'Тарифный план'
        }
    }
}
